import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

type ButtonProps = {
  label: string;
  onClick?: () => void;
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
  starticon?: React.ReactNode;
  endicon?: React.ReactNode;
  disabled?: boolean;
  isLoading?: boolean;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
  size?: 'small' | 'medium' | 'large';
};

const Buttons: React.FC<ButtonProps> = ({
  label,
  onClick,
  backgroundColor = 'var(--primary-color)',
  borderColor = 'transparent',
  textColor = '#fff',
  starticon,
  endicon,
  disabled = false,
  isLoading = false,
  fullWidth = true,
  sx,
  size = 'medium',
}) => {
  return (
    <Button
      fullWidth={fullWidth}
      variant="contained"
      onClick={onClick}
      disabled={disabled || isLoading}
      startIcon={!isLoading ? starticon : null}
      endIcon={!isLoading ? endicon : null}
      sx={{
        backgroundColor,
        borderColor,
        color: textColor,
        border: `1px solid ${borderColor}`,
        textTransform: 'none',
        fontSize: size === 'small' ? '11px' : size === 'large' ? '16px' : '14px',
        padding: size === 'small' ? '2px 5px' : size === 'large' ? '12px 20px' : '8px 15px',
        borderRadius: 9,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
          backgroundColor,
          opacity: 0.8,
        },
        ...sx,
      }}
    >
      {isLoading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : label}
    </Button>
  );
};

export default Buttons;
